import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ContactUsService } from '../../services/contactus.service';
import { LayoutService } from '../../services/layout/layout.service';

@Component({
    selector: 'app-footer-nav-menu',
    templateUrl: './footer-nav-menu.component.html',
    styleUrls: ['../../app.component.scss', './footer-nav-menu.component.scss'],
    standalone: false
})
export class FooterNavMenuComponent implements OnInit {
  currentYear = new Date().getFullYear();
  showFooter$: Observable<boolean> = of(false);

  constructor(
    private contactUsService: ContactUsService,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    this.showFooter$ = this.layoutService.getShowFooter();
  }

  contactUs() {
    this.contactUsService.changeCurrentAction('contact');
  }
}
